export const FULL_CPS_LIST = 'FULL_CPS_LIST';
export const FULL_CPS_LIST_SUCCESS = 'FULL_CPS_LIST_SUCCESS';
export const FULL_CPS_LIST_ERROR = 'FULL_CPS_LIST_ERROR';